import { render, staticRenderFns } from "./CRMBrandCreateEditModal.vue?vue&type=template&id=7af9385e"
import script from "./CRMBrandCreateEditModal.vue?vue&type=script&lang=js"
export * from "./CRMBrandCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports